import React from 'react';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

export const LCDateRangePicker = props => <RangePicker {...props} />;
